import React, { useState } from 'react'
import { useGoogleLogin } from '@react-oauth/google';
import { RiGoogleFill } from 'react-icons/ri';
import jwtDecode from "jwt-decode";
import axios from 'axios';
import { SERVER_URL } from '../../../ServerUrl';
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { SetUserdataOperator } from '../../../Redux/userReducer';
import { FcGoogle } from "react-icons/fc";
import Swal from 'sweetalert2';

const GoogleSignUp = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [googleToken, setGoogleToken] = useState('');
    const login = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            console.log("Token Response:", tokenResponse);
            try {
                const userInfo = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
                    headers: {
                        Authorization: `Bearer ${tokenResponse.access_token}`,
                    },
                });
                console.log("UserInfo", userInfo.data)

                const resp = await axios.post(
                    `${SERVER_URL}/auth/google-login`,
                    {
                        name: `${userInfo?.data.given_name} ${userInfo?.data.family_name}`,
                        email: userInfo?.data.email,
                        googleId: userInfo?.data.sub,
                    }
                );

                console.log(resp, "123data")
                Swal.fire({
                    icon: "success",
                    title: "Congratulations",
                    text: "You have successfully signed in",
                });
                dispatch(SetUserdataOperator(resp?.data));
                history.push("/")
            } catch (error) {
                console.log("Error fetching user info:", error);
                Swal.fire({
                    icon: "error",
                    title: "error",
                    text: error?.response?.data?.message,
                });
            }
        },
        onError: () => {
            console.log('Login Failed');
        },
    });
    return (
        <>
            <button
                className="custom-google-btn"
                onClick={() => login()}
            >
                {/* <RiGoogleFill className="socialIcons" /> */}
                <FcGoogle />
                Sign in with google
            </button>
        </>
    )
}

export default GoogleSignUp
